import { FC } from 'react'

import { TournamentEvent } from '@img-arena/consoles-api-streaming'
import DownloadIcon from '@mui/icons-material/Download'

import { ActionMenuItem } from '../ActionMenuItem/ActionMenuItem'
import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike } from '../index.types'

type Props = MenuItemLike & {
  onClick: (row: TournamentEvent) => Promise<void> | void
  isActive?: ((row: TournamentEvent) => boolean) | boolean
}

export const ActionImportEventsItem: FC<Props> = ({
  onClick,
  displaySeparately,
  isActive = true
}) => {
  const { row } = useActionMenuContext<TournamentEvent>()

  if (
    (typeof isActive === 'function' && !isActive(row)) ||
    (typeof isActive === 'boolean' && !isActive)
  ) {
    return null
  }

  return (
    <ActionMenuItem
      onClick={() => onClick(row)}
      icon={<DownloadIcon />}
      text="Import"
      displaySeparately={displaySeparately}
    />
  )
}
